
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import opciones from './barra-ventas-opciones.vue';
    import pedidos from './barra-ventas-pedidos.vue';
    import facturas from './barra-ventas-facturas.vue';
    import editar_cliente from './barra-ventas-editar-cliente.vue';
    import { Controlador as ControladorPrincipal } from '../../../controlador';
import { Observacion } from '@/__env/lib/Ventas/Pedidos/Observaciones';
import { Wait } from '@/__env/ext';
import { Utiles } from '@/__env/pluggins/event-bus';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            opciones,
            pedidos,
            facturas,
            editar_cliente,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get Chat() { return this.Controlador.Chat; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }
        public get Modo() { return this.ControladorBarras.Vista.Modo; }
        public set Modo( x: string ) { this.ControladorBarras.Vista.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.ReservarEspacioDerecha.Espacio; }
        public Abierto: boolean = false;

        protected focused: boolean = false;
        public get Focused()
        {
            return this.focused
        }

        public set Focused( x: boolean )
        {
            this.focused = x;
            if ( this.focused )
            {
                this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 400;

            }
            else
            {
                this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 300;
            }

        }

        public Cargando: boolean = false;
        public Observaciones: Observacion[] = [];

        public Observacion: string = '';
        public EnviarAPlataforma: boolean = false;
        public SoloPendientes: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        Cerrar()
        {
            this.Observacion = '';
            this.Focused = false;
        }

        async mounted()
        {
            this.Cargando = true;
            this.Observaciones.clear();
            await Wait( 1000 );
            this.Observaciones.clear();
            let e = await Observacion.find( { cliente: this.Chat.Cliente.Id } );
            if ( !e.Error && e.Items.hasRows() )
                this.Observaciones = e.Items;
            this.Cargando = false;
            this.$nextTick( () => Utiles.ElementScrollBottom( document.getElementById( 'div-observaciones' ) ) );

        }


        async Enviar()
        {

            if ( this.Observacion )
            {
                let bb: any = { cliente: this.Chat.Cliente.Id, order: 'fecha', sort: 'DESC',limit: 1 };
                let ped = await Pedido.find( bb );

                if ( !ped.Error && ped.Items.hasRows() )
                {
                    let o = this.Observacion;
                    this.Observacion = '';
                    let ob = new Observacion();
                    ob.Observacion = o;
                    ob.Pedido = ped.Items[0].Id;
                    if ( await ob.save( false ) )
                    {
                        this.Observaciones.push( ob );
                        this.$nextTick( () => Utiles.ElementScrollBottom( document.getElementById( 'div-observaciones' ) ) );
                    }
                    else
                    {
                        Utiles.Notificaciones.Error( 'Error al enviar la observación' );
                    }
                }

            }

        }
    }
